import service from "@/utils/request";
/**
 * 请求 get
 * @param data
 * @returns {*}
 */

export function ecologicalProjectsInfoList(data) {
  return service({
    url: `/generate/ecologicalProjectsInfo/list`,
    method: "get",
    data: data,
  });
}
export function login(data) {
  return service({
    url: `/login`,
    headers: {
      isToken: false,
    },
    method: "POST",
    data: data,
  });
}
//查询产品
export function listProduct(data) {
  return service({
    url: `/ecoProducts/product/list`,
    method: "get",
    data: data,
  });
}

//查询数据列表
export function listDataManagement(data) {
  return service({
    url: `/ecoProducts/dataManagement/dataAndDataTypeList`,
    method: "get",
    data: data,
  });
}

//查询公司信息
export function listCompanyInformation(data) {
  return service({
    url: `/ecoProducts/companyInformation/list`,
    method: "get",
    data: data,
  });
}

//获取相应页面的条件筛选
export function dataType(menuName) {
  return service({
    url: `/ecoProducts/dataManagement/getDataType/` + menuName,
    method: "get",
    // data: data
  });
}

export function releaseNewsInfoList(data) {
  return service({
    url: `/generate/releaseNewsInfo/list`,
    method: "get",
    data: data,
  });
}
export function sendMailApi(data) {
  return service({
    url: `/server/sendMail`,
    method: "post",
    data: data,
  });
}
export function checkLinkEmbeddedIframe(data) {
  return service({
    url: `/server/checkLinkEmbeddedIframe`,
    method: "get",
    data: data,
  });
}

export function getCompanyInfo(data) {
  return service({
    url: `/generate/companyInfo/list`,
    method: "get",
    headers: {
      isToken: false,
    },
    data: data,
  });
}

export function getDictApi(data) {
  return service({
    url: `/system/dict/data/list`,
    method: "get",
    data: data,
  });
}

// http://localhost/serverApi/?pageNum=1&pageSize=10&dictType=page_link
